<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>{{$t('osm.renewal.history')}}</h4>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-btn @click="exportReport" variant="success"><i class="fa fa-download mr-2"></i>{{$t('dw.general.export')}}</b-btn>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="table" vuexModule="Dw" searchAction="getRenewalReport" type="dw" :columns="columns" :autoSearchFilters="autoSearchFilters" :filters="filters" v-model="currentFilters"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { FITSearchableTable, FITFormCard, FITAlert, FITAutoSearch } from '@/components'
import { mapGetters } from 'vuex';
import { saveAs } from 'file-saver/FileSaver';
export default {
  name: 'ReportRenewalHistory',
  mounted() {},
  computed: {
    ...mapGetters(['getTranslatedArray']),
  },
  methods: {
    exportReport() {
      var filters = JSON.parse(JSON.stringify(this.currentFilters));
      filters.export = 1
      var params = this.$options.filters.removeEmptyObj(filters);
      // console.debug(params);

      this.$store.dispatch('Dw/exportRenewalReport', params).then((json) => {
        var fileName = json.headers['content-disposition'];
        fileName = fileName.split(' ').join('');
        fileName = fileName.split('attachment;filename=').join('');
        var blob = new Blob([json.data]);
        saveAs(blob, fileName);

        // download(blob, '123.xls');
      })
    },
    getTranslated(type, key) {
      // console.log(type, key);
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Dw', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
  },
  data() {
    return {
      currentFilters: {},
      autoSearchFilters: [{
        label: this.$t('dw.general.agent'),
        key: 'agentID',
        searchParams: {
          placeholder: ' Type to search',
          dest: 'option',
          paras: [{ key: 'type', value: 'agent' }],
          showItems: ['englishFullname', 'chineseFullname']
        }
      }, {
        label: this.$t('dw.general.team'),
        key: 'teamID',
        searchParams: {
          placeholder: ' Type to search',
          dest: 'option',
          paras: [{ key: 'type', value: 'team' }],
          showItems: ['teamCode']
        }
      }],
      columns: [{
          key: 'policyNumber',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyNumber'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row);
          }
        },
        {
          key: 'policyReference',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyReference'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row);
          }
        }, {
          key: 'productEnglishName',
          label: this.$t('osm.product.productName'),
          sortable: true,
          formatter: (row, key, item) => {
            return item.productEnglishName + "</br>" + item.productChineseName;
          }
        },
        {
          key: 'policyType',
          label: this.$t('osm.renewal.list.policyType'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
        {
          key: 'serviceAgentEnglishName',
          label: this.$t('dw.report.renewal.agent'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(item.serviceAgentEnglishName) + "</br>" + this.$options.filters.isEmpty(item.serviceAgentChineseName)
          }
        },
        {
          key: 'chineseNameCustomer',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyOwner'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(item.englishNameCustomer) + "</br>" + this.$options.filters.isEmpty(item.chineseNameCustomer)
          }
        },
        {
          key: 'nextPaymentDate',
          label: this.$t('osm.renewal.list.nextPaymentDate'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.date(row)
          }
        },
        {
          key: 'modalPremium',
          label: this.$t('osm.renewal.list.modalPremium'),
          sortable: true,
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'updateTime',
          label: this.$t('osm.renewal.list.updateTime'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.date(row);
          }
        }

      ],
      filters: [{
        label: this.$t('osm.renewal.list.policyType'),
        key: 'policyType',
        type: 'select',
        default: null
      }, {
        label: this.$t('osm.renewal.list.dateFromUpdateTime'),
        key: 'dateFromUpdateTime',
        type: 'datetime',
        default: ''
      }, {
        label: this.$t('osm.renewal.list.dateToUpdateTime'),
        key: 'dateToUpdateTime',
        type: 'datetime',
        default: ''
      }],
    }
  },
  components: {
    FITSearchableTable,
    FITFormCard,
    FITAlert,
    FITAutoSearch
  }
}

</script>



// WEBPACK FOOTER //
// src/Dw/containers/ReportRenewalHistory.vue